module.exports = __webpack_public_path__ + "img/chr_ts_90_25.14772ebb.png";